/**
 * The count of providers a customer can connect today, single-sourced here
 * so every marketing surface prints the same true number instead of the
 * "500+"/"1,000+" figures that used to be typed independently in 8 places.
 *
 * It is the number of `integrations-catalog.json` providers (generated from
 * `backend/app/integrations/catalog.py`) that are NOT `comingSoon` — 34 of
 * 62 on 2026-09-26. It is a plain constant rather than an import of the
 * JSON so client components that print it don't ship the whole catalog;
 * `integrations.test.tsx` fails if it drifts from the generated catalog.
 * Print it as an exact number ("34 connected apps"), never "34+".
 */
export const CONNECTED_APP_COUNT = 34;
